import React from 'react';
import parse from 'html-react-parser';
import Link from '../utils/link';

const Partners = ({title, content, items, hashId}) => (
  <section className="partners" id={hashId}>
    <div className="partners__inner">
      <div className="partners__heading">
        <h2>{title}</h2>

        <p>{parse(content)}</p>
      </div>

      <div className="partners__content">
        {
          items?.map((el, index) => (
            <div key={index} className="partners__content--item">
              <Link to={el.link}>
                {el.title}
              </Link>
            </div>
          ))
        }
      </div>
    </div>
  </section>
);

Partners.defaultProps = {
  title: ``,
  content: ``,
  items: [],
};

export default Partners;